// Ephemeral execution windows from the server's existing SDK trace clock.
// Count their union: parallel tools must not inflate wall-clock waiting time.
export type ToolTiming = {
  messageId: string;
  toolCallId: string;
  startedAtMs: number;
  endedAtMs: number;
};

export function parseToolTiming(value: unknown): ToolTiming | null {
  if (!value || typeof value !== 'object') return null;
  const timing = value as ToolTiming;
  if (typeof timing.messageId !== 'string' || !timing.messageId) return null;
  if (typeof timing.toolCallId !== 'string' || !timing.toolCallId) return null;
  if (!Number.isFinite(timing.startedAtMs) || !Number.isFinite(timing.endedAtMs)) return null;
  if (timing.startedAtMs < 0 || timing.endedAtMs < timing.startedAtMs) return null;
  return timing;
}

export function createLaneToolTiming() {
  const windows = new Map<string, [number, number]>();
  return (timing: ToolTiming): number => {
    if (!windows.has(timing.toolCallId))
      windows.set(timing.toolCallId, [timing.startedAtMs, timing.endedAtMs]);
    const sorted = [...windows.values()].sort((a, b) => a[0] - b[0]);
    let total = 0;
    let end = 0;
    for (const [start, finish] of sorted) {
      total += Math.max(0, finish - Math.max(start, end));
      end = Math.max(end, finish);
    }
    return total;
  };
}
